<div class="container-fluid px-3">
    <app-assign-staff [customerDataInput]="customerData"></app-assign-staff>
    <app-list-partner-staff [customerDataInput]="customerData"></app-list-partner-staff>
</div>